import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { Checkbox, Label } from '@e2n/ui';
import { useTranslation } from 'react-i18next';

export function MitarbeiterSpeicheroptionenContent() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  return (
    <div className="flex flex-col gap-4">
      <span className="text-neutrals-900 text-base font-bold leading-6">
        {t(
          'domain.mitarbeiter.create.speicheroptionen.dialog.app_fragebogen.title',
        )}
      </span>
      <form.AppField name="speicheroptionen.personalzugang">
        {(field) => (
          <div className="flex gap-2 items-start">
            <Checkbox
              id={field.name}
              name={field.name}
              checked={field.state.value}
              onCheckedChange={(e) => field.handleChange(!!e)}
              onBlur={field.handleBlur}
            />
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-2">
                <Label
                  htmlFor={field.name}
                  className="text-neutrals-900 text-sm font-normal leading-5 w-fit">
                  {t(
                    'domain.mitarbeiter.create.speicheroptionen.dialog.app_fragebogen.personalzugang.label',
                  )}
                </Label>
                <span className="text-neutrals-800 text-sm font-normal leading-5">
                  {t(
                    'domain.mitarbeiter.create.speicheroptionen.dialog.app_fragebogen.personalzugang.description',
                  )}
                </span>
              </div>
              {field.state.value && (
                <form.AppField name="person.kontakt.email">
                  {(field) => (
                    <field.TextInput
                      label={t(
                        'domain.mitarbeiter.create.steps.person.kontakt.form.email.label',
                      )}
                    />
                  )}
                </form.AppField>
              )}
            </div>
          </div>
        )}
      </form.AppField>
    </div>
  );
}
